module.exports = __webpack_public_path__ + "img/plan-b-info-title.5cf77cc4.png";